import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import '../css/OpportunityEngine.css'
import '../css/AiToolResultsPage.css'
import OpportunityResults from '../components/opportunityEngine/OpportunityResults'
import ProductionToolsHeader from '../components/productionTools/ProductionToolsHeader'
import AiToolResultsHero from '../components/productionTools/AiToolResultsHero'
import AiToolResultsLoading from '../components/productionTools/AiToolResultsLoading'
import { useAiToolResultsPage } from '../hooks/useAiToolResultsPage'
import { AI_TOOL_TYPES } from '../utils/aiTool/payment'

const STREAM_MESSAGES = [
  'Scanning PitchBlu...',
  'Analyzing opportunities...',
  'Matching posts to your profile...',
  'Scoring and ranking your top 5...',
  'Preparing your results...',
]

const OpportunityEngineResultsPage = () => {
  const { loading, error, streamMsg, resultState, resetToTool } =
    useAiToolResultsPage(AI_TOOL_TYPES.OPPORTUNITY_ENGINE, STREAM_MESSAGES)

  const resultsRef = useRef(null)

  useEffect(() => {
    if (resultState && resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [resultState])

  return (
    <div className="production-tools-theme opportunity-engine-page ai-tool-results-page">
      <Helmet>
        <title>Opportunity Engine Results | PitchBlu</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Anton&family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <ProductionToolsHeader badge="Opportunity Engine" />

      <AiToolResultsHero
        toolType={AI_TOOL_TYPES.OPPORTUNITY_ENGINE}
        loading={loading}
      />

      {loading && (
        <AiToolResultsLoading
          label="● AI is finding your best opportunities"
          streamMsg={streamMsg}
        />
      )}

      {!loading && error && (
        <div className="ai-tool-results-error wrap">
          <div className="err on">{error}</div>
          <div style={{ marginTop: 16 }}>
            <button type="button" className="btn-new" onClick={resetToTool}>
              Back to Opportunity Engine
            </button>
          </div>
        </div>
      )}

      {!loading && resultState && (
        <div ref={resultsRef}>
          <OpportunityResults
            result={resultState.result}
            inputs={resultState.resultInputs}
            onReset={resetToTool}
          />
        </div>
      )}
    </div>
  )
}

export default OpportunityEngineResultsPage
